import { string } from 'yup';

export const maritalStatusValidation = (required: boolean) =>
  string().when([], {
    is: () => required,
    then: string().required('Please enter a value'),
    otherwise: string().notRequired(),
  });
